import { gql } from '@apollo/client';

export const ROOM_RESERVATIONS_BY_FUNERAL_SERVICE_ID = gql`
  query GetRoomReservationsByFuneralServiceId(
    $where: Room_reservationWhereInput!
  ) {
    room_reservations(where: $where) {
      edges {
        node {
          from
          to
          room_pointer {
            objectId
            name
          }
        }
      }
    }
  }
`;
